import React from "react";
import Modal from "../../Elements/Modal/Modal";
import { useSelector } from "react-redux";
import styles from "../../Styles/Modules/Modal.module.scss";
import Button from "../../Elements/Button/Button";
import { useTranslation } from "react-i18next";
import {
  disableBackgroundMusicAndCloseModal,
  enableBackgroundMusicAndCloseModal,
} from "../../State/Slices/soundsSlice";

const IntroModal = () => {
  const { modalOpen } = useSelector((state) => state.modal);
  const { t } = useTranslation();

  return (
    <div
      className={`${styles.modalOverlay} ${
        modalOpen === "intro" ? styles.modalOverlayActive : ""
      }`}
    >
      <Modal
        name="intro"
        modifier="modalIntro"
        active={modalOpen}
        title={t("enable_sound")}
      >
        <Button
          text="yes"
          title="yes"
          modifier="buttonStandard"
          action={() => enableBackgroundMusicAndCloseModal()}
        />

        <Button
          text="no"
          title="no"
          modifier="buttonStandard"
          action={() => disableBackgroundMusicAndCloseModal()}
        />
      </Modal>
    </div>
  );
};
export default IntroModal;
